import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "40",
  height: "36",
  x: "4",
  y: "6",
  stroke: "#475467",
  "stroke-width": "2",
  rx: "7"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#475467",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M16 19c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C17.602 16 18.068 16 19 16h10c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C32 17.602 32 18.068 32 19M20 32h8m-5.75-16v16m3.5-16v16"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }